import { Helmet } from 'react-helmet';
import RegisterUserStepForm from './RegisterUserStepForm/RegisterUserStepForm';

export default () => {
  return (
    <>
      <Helmet>
        <title>Inscription</title>
      </Helmet>
      <RegisterUserStepForm />
    </>
  );
};
